/**
 * EC文字情報編集用VOクラス
 *
 * @export KYMW5002InputModel
 * @class KYMW5002InputModel
 */
export class KYMW5002InputModel {

  /** 呼び出し元フラグ（"1"：CWS商品マスタ／"2"：商品企画メンテナンス／"3"：商品画像情報） */
  public flg = String('');
  /** 受注コード */
  public orderCode = String('');
  /**  Ｐコード */
  public pcode = String('');
  /** 呼び出し元生協コード */
  public pushCoopCode = String('');
  /** 商品名 */
  public goodsName = String('');
  /** 規格名 */
  public goodsStandardName = String('');

  // チェック可能生協配列
  /** チェック可能生協コード */
  public enableCoopCodeVOList: Array<any> = [];

  // 設定画像配列
  /** UseImageInfoVOの配列 */
  public useImageInfoVOList: Array<any> = [];

  // 設定生協配列
  /** SelectCoopInfoVOの配列 */
  public selectCoopInfoVOList: Array<any> = [];

}
